import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
// The interface typeface, bundled and served by the appliance like the logo —
// never fetched from outside (§4, IMPLEMENTATION.md decision 28).
import '@fontsource-variable/inter'
import './styles.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
